import Step from '../../step/step'
import { PaymentMethodSelector } from '../../payment-methods-step/components/payment-method-selector'
import { PaymentMethodActionButton } from '../../payment-methods-step/components/payment-method-action-button'
import { PaymentMethodSecureNotice } from '../../payment-methods-step/components/payment-method-secure-notice'
import DonationSummary from './components/donation-summary/donation-summary'
import { Section } from '../section/section'
import useConfig from 'modules/config/state/use-config'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../redux/store'
import { capitalizePhrase } from '../../../../../utils/capitalize'
import { DEFAULT_THEME_COLORS } from '../../../../../css/theme'
import { UiIcon } from '../../../../ui/atoms/Icon'
import styled from '@emotion/styled'
import { Tooltip } from '../../../../ui/atoms/Tooltip'
import React from 'react'
import { useTranslation, Trans } from 'next-i18next'

const DedicationHeader = styled.div`
  background-color: #f0fce9;
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`

const TermsOfService = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  line-height: 150%;
  letter-spacing: -0.1px;
  margin-bottom: 10px;
  a {
    color: inherit;
    text-decoration: underline;
    white-space: nowrap;
  }
`

const PaymentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
`

const PaymentTitle = styled.h2`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 8px;
`

export default function SingleStep() {
  const config = useConfig()
  const urlParams = useSelector((state: RootState) => state.urlParams)
  const dedication = urlParams.dedication
  const { t } = useTranslation()
  const orgPrivacyPolicyLink = config.organization?.privacy_policy_url

  return (
    <Step.Root header={{ headline: `${config.campaignName}` }}>
      <Step.Content>
        {dedication && (
          <DedicationHeader>
            <UiIcon
              aria-hidden="true"
              name="donation"
              color={DEFAULT_THEME_COLORS['--theme-color--status-error']}
              w={20}
              h={20}
            />
            Dedicated to <strong>{capitalizePhrase(dedication)}</strong>
            <Tooltip
              text={t('You can personalize and send your eCard after checkout.')}
              placement="top"
            >
              <UiIcon name="info" color="#1B1918" w={18} style={{ marginTop: '2px' }} />
            </Tooltip>
          </DedicationHeader>
        )}
        <PaymentHeader>
          <PaymentTitle>Your Payment</PaymentTitle>
          <PaymentMethodSecureNotice />
        </PaymentHeader>
        <PaymentMethodSelector />
        <Section title="Donation Summary">
          <DonationSummary />
        </Section>
        <TermsOfService>
          <Trans
            i18nKey="termsOfService"
            components={{
              orgPrivacyPolicyLink: <a target="_blank" href={orgPrivacyPolicyLink} />,
              terms: <a target="_blank" href="https://pro.gofundme.com/c/legal/terms/" />,
              privacy: (
                <a target="_blank" href="https://pro.gofundme.com/c/legal/privacy-notice/" />
              ),
            }}
          />
        </TermsOfService>
      </Step.Content>
      <PaymentMethodActionButton
        fallbackText="Complete Donation"
        dataIdPrefix="single-step-payment-button"
      />
    </Step.Root>
  )
}
